/** German dictionary. */
const de = {
  nav: {
    dashboard: 'Dashboard',
    products: 'Produkte',
    website: 'Website',
    advertorials: 'Advertorials',
    ads: 'Anzeigen',
    splitTesting: 'A/B-Tests',
    findUpsells: 'Upsells finden',
    findProducts: 'Produkte finden',
    aiChat: 'KI-Chat',
    referAndEarn: 'Empfehlen & verdienen',
    settings: 'Einstellungen',
    notifications: 'Benachrichtigungen',
    aiSuggestions: 'KI-Vorschläge',
    noSuggestions: 'Noch keine Vorschläge — schau bald wieder vorbei!',
    caughtUp: 'Alles erledigt',
    noNotificationsBody: 'Hier sagen wir dir Bescheid, wenn eine Erstellung fertig ist oder die KI einen Vorschlag für deinen Shop hat.',
    groups: {
      create: 'Erstellen',
      grow: 'Wachsen',
      assistant: 'Assistent',
      account: 'Konto',
    },
  },
  common: {
    generate: 'Generieren',
    publish: 'Veröffentlichen',
    download: 'Herunterladen',
    downloadAll: 'Alle herunterladen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    back: 'Zurück',
    next: 'Weiter',
    continue: 'Fortsetzen',
    done: 'Fertig',
    view: 'Ansehen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    close: 'Schließen',
    loading: 'Wird geladen...',
    loadingStore: 'Dein Shop wird geladen…',
    product: 'Produkt',
    selectProduct: 'Produkt auswählen',
    pleaseChooseProduct: 'Bitte wähle ein Produkt',
    markComplete: 'Als abgeschlossen markieren',
    copyHtml: 'HTML kopieren',
    settingsSaved: 'Einstellungen gespeichert',
    alreadyGenerating: 'Das wird bereits generiert — sieh dir die Fortschrittsanzeige unten rechts an.',
    generationStarted: 'Generierung gestartet — du kannst diese Seite verlassen, wir benachrichtigen dich, sobald sie fertig ist.',
    open: 'Öffnen',
    tryAgain: 'Erneut versuchen',
    viewLive: 'Live-Seite ansehen',
    preview: 'Vorschau',
  },
  dashboard: {
    suggestions: 'KI-Vorschläge',
    dismiss: 'Ausblenden',
    adPerformance: 'Anzeigenleistung — letzte 30 Tage',
    badgeNew: 'Neu',
    badgeComingSoon: 'Bald verfügbar',
    metrics: {
      totalSpend: 'Gesamtausgaben',
      roas: 'ROAS',
      purchases: 'Käufe',
      revenue: 'Umsatz',
      clicks: 'Klicks',
      ctr: 'CTR',
    },
    capabilities: {
      buildProducts: {
        title: 'Produkte von Grund auf erstellen',
        desc: 'Lade ein Foto hoch oder füge eine URL ein — die KI erstellt das komplette Produkt, Bilder, Preise und eine conversion-starke Produktseite.',
      },
      fullWebsite: {
        title: 'Komplette Website erstellen',
        desc: 'Startseite, Über uns, Kontakt — ein kompletter Marken-Shop rund um dein Produkt.',
      },
      imageAds: {
        title: 'Bild-Anzeigen',
        desc: '20 professionelle DTC-Werbecreatives pro Produkt, bereit für Meta.',
      },
      videoAds: {
        title: 'Video-Anzeigen',
        desc: 'KI-generierte Videoanzeigen, die auf Meta und TikTok nachweislich konvertieren.',
      },
      advertorials: {
        title: 'Advertorials',
        desc: 'Redaktionelle Artikel, die verkaufen — Story, Recherche, Listicle und mehr.',
      },
      releaseAds: {
        title: 'Anzeigen erstellen & schalten',
        desc: 'Die KI schreibt den Text, baut die Kampagne und veröffentlicht sie in deinem Meta-Konto.',
      },
      splitTesting: {
        title: 'A/B-Tests',
        desc: 'Teste Preise, Angebote, Bilder, Texte und Produktseiten, um den Gewinner zu finden.',
      },
      scaling: {
        title: 'Skalierungs-Vorschläge',
        desc: 'Die KI verfolgt Gewinner-Anzeigen und sagt dir genau, was du wann skalieren solltest.',
      },
      winningAds: {
        title: 'Gewinner-Anzeigen erkennen',
        desc: 'Die KI findet deine Top-Performer und erstellt weitere Anzeigen auf Basis dessen, was funktioniert.',
      },
      aiAssistant: {
        title: 'KI-Assistent',
        desc: 'Frag ihn alles — Preis ändern, Produktseite korrigieren, Test aufsetzen, Anzeige skalieren.',
      },
      themeEditorAi: {
        title: 'Autonoma KI im Theme-Editor',
        desc: 'Klicke im Shopify-Theme-Editor auf einen Abschnitt und sag der KI, was sich ändern soll – in jedem Theme.',
      },
      mobileApp: {
        title: 'Vom Handy aus verwalten',
        desc: 'Führe deinen Shop und starte Anzeigen unterwegs über die Mobile-App.',
      },
    },
    mobileAppModal: {
      title: 'Hol dir die Autonoma-App auf dein Handy',
      subtitle: 'Kopiere den Link und öffne ihn auf deinem Gerät — oder öffne direkt den Store.',
      ios: 'iOS — App Store',
      android: 'Android — Google Play',
      open: 'Öffnen',
      copyLink: 'Link kopieren',
      copied: 'Kopiert',
      close: 'Schließen',
    },
    title: 'Dashboard',
    subtitle: 'Erstelle Produkte, Seiten, Anzeigen und Websites – und lass die KI sie laufend verbessern.',
    primaryAction: 'Produkt erstellen',
    capabilitiesTitle: 'Alles, was Autonoma kann',
    capabilitiesSubtitle: 'Wähle ein Tool, um loszulegen. Funktionen mit „Automatisch“ laufen von selbst, sobald deine Anzeigen Daten liefern.',
    automatic: 'Automatisch',
    automaticHint: 'Läuft von selbst, sobald deine Anzeigen Daten liefern – nichts einzurichten.',
    gettingStarted: {
      title: 'Erste Schritte',
      progress: '{done} von {total} erledigt – der nächste Schritt ist hervorgehoben.',
      hide: 'Ausblenden',
      doneCta: 'Erledigt',
      product: {
        title: 'Produkt erstellen',
        desc: 'Lade ein Foto hoch – wir erstellen Produkt, Bilder und Seite.',
        cta: 'Produkt erstellen',
      },
      ads: {
        title: 'Anzeigen erstellen',
        desc: 'Bildanzeigen, Videoanzeigen und Anzeigentexte für dein Produkt.',
        cta: 'Anzeigen erstellen',
      },
      meta: {
        title: 'Meta verbinden und starten',
        desc: 'Verbinde dein Werbekonto und veröffentliche eine Kampagne.',
        cta: 'Meta verbinden',
      },
      website: {
        title: 'Website erstellen',
        desc: 'Ein kompletter Shop im Look deiner Marke rund um deine Produkte.',
        cta: 'Website erstellen',
      },
    },
  },
  ads: {
    imageN: 'Bild {n}',
    brief: {
      label: 'Briefing', open: 'Bild-Briefing ansehen', title: 'Bild-Briefing', close: 'Schließen',
      layout: 'Layout', purpose: 'Zweck', attempts: '{n} Versuche', textRendered: 'Text von uns gesetzt', compositeUsed: 'Echtes Produkt eingefügt',
      pass: 'bestanden', fail: 'nicht bestanden', gateIdentity: 'Identität', gateText: 'Text', gateAesthetics: 'Ästhetik', gateArrows: 'Pfeile',
      overlays: 'Text im Bild (exakt)', camera: 'Kamera', lighting: 'Licht', background: 'Hintergrund', negativeSpace: 'Freiraum',
      finalPrompt: 'Finaler Prompt', copy: 'Kopieren', copied: 'Kopiert',
    },
    title: 'Anzeigen',
    subtitle: 'Meta-Anzeigen erstellen, prüfen und veröffentlichen — Schritt für Schritt',
    tabCreate: 'Neu erstellen',
    tabInProgress: 'In Arbeit',
    tabCompleted: 'Abgeschlossen',
    tabStrategy: 'Strategie',
    stepSetup: 'Einrichtung',
    stepCreatives: 'Creatives',
    stepCopy: 'Texte',
    stepPublish: 'Veröffentlichen',
    generateAds: 'Anzeigen generieren',
    clickToSelect: 'Klicke auf Bilder, um sie auszuwählen.',
    campaignSetup: 'Kampagnen-Einrichtung',
    campaignName: 'Kampagnenname',
    adSetName: 'Anzeigengruppen-Name',
    dailyBudget: 'Tagesbudget',
    countries: 'Länder',
    publishAds: 'Anzeigen veröffentlichen',
    connectAdAccount: 'Werbekonto verbinden',
    setup: {
      account: {
        title: 'Verbinde dein Meta-Werbekonto, um zu veröffentlichen',
        body: 'Deine Anzeigen sind fertig. Zum Veröffentlichen braucht es ein verbundenes Meta-Werbekonto – das dauert in den Einstellungen etwa eine Minute, danach kommst du hierher zurück.',
        cta: 'Werbekonto verbinden',
      },
      page: {
        title: 'Wähle eine Facebook-Seite, um zu veröffentlichen',
        body: 'Meta braucht eine Facebook-Seite, um die Anzeigenmotive zu erstellen. Wähle in den Einstellungen eine aus und komm dann hierher zurück.',
        cta: 'Facebook-Seite wählen',
      },
      pixel: {
        title: 'Richte dein Meta-Pixel ein, um zu veröffentlichen',
        body: 'Kaufoptimierte Anzeigen brauchen dein Pixel mit dem Kauf-Ereignis. Richte es in den Einstellungen ein und komm dann hierher zurück.',
        cta: 'Pixel einrichten',
      },
    },
    connectToPublish: 'Bitte verbinde dein Werbekonto, um zu veröffentlichen.',
    adCopy: 'Anzeigentext',
    generateCopy: 'Text generieren',
    useExistingCopy: 'Vorhandenen Text verwenden',
    noInProgress: 'Keine Anzeigen in Arbeit. Starte eine im Tab „Neu erstellen" — dein Fortschritt wird nach jedem Schritt automatisch gespeichert.',
    noCompleted: 'Noch keine abgeschlossenen Kampagnen.',
    createNewAds: 'Neue Anzeigen erstellen',
    imageAds: 'Bild-Anzeigen',
    videoAds: 'Video-Anzeigen',
    writeManually: 'Manuell schreiben',
    manualCopyTitle: 'Schreibe deinen eigenen Anzeigentext',
    manualCopyHelp: 'Der erste Haupttext und die erste Überschrift sind Pflicht — der Rest ist optional, aber empfohlen, damit Meta mehr Varianten testen kann.',
    primaryText: 'Haupttext',
    headline: 'Überschrift',
    required: 'erforderlich',
    recommended: 'empfohlen',
    manualValidation: 'Füge mindestens den ersten Haupttext und die erste Überschrift hinzu, um fortzufahren.',
    emptyInProgressTitle: 'Nichts in Arbeit',
    emptyCompletedTitle: 'Noch keine abgeschlossenen Anzeigen-Erstellungen',
    emptyCompletedBody: 'Abgeschlossene Erstellungen erscheinen hier schreibgeschützt – starte eine unter „Neu erstellen“.',
    progressTitle: 'Deine Anzeigen werden erstellt',
    progressSteps: {
      study: 'Deine Produktfotos werden analysiert',
      design: 'Deine Werbemotive werden gestaltet',
      render: 'Deine Bilder werden gerendert',
      renderVideo: 'Deine Bilder und Videos werden gerendert',
      review: 'Alles wird zur Prüfung vorbereitet',
    },
    cancelGeneration: 'Diese Erstellung abbrechen',
    cancelConfirm: 'Diese Erstellung abbrechen?',
    cancelTitle: 'Erstellung abbrechen',
    liveTitle: 'Deine Kampagne ist live 🚀',
    liveBody: '{n} Anzeige(n) laufen und geben dein Tagesbudget aus.',
    pausedTitle: 'Deine Kampagne ist erstellt – sie ist ausgeschaltet 🎉',
    pausedBody: 'Noch wird nichts ausgegeben. Schalte sie ein, wenn du bereit bist, oder prüfe sie zuerst in Meta.',
    viewInAdsManager: 'Im Werbeanzeigenmanager ansehen',
    createMore: 'Weitere Anzeigen erstellen',
    turnOnTitle: 'Kampagne einschalten',
    turnOnDesc: 'Gibt dein Tagesbudget sofort aus.',
    turnOn: 'Einschalten',
    reviewInMetaTitle: 'Zuerst in Meta prüfen',
    reviewInMetaDesc: 'Prüfe Anzeigen, Zielgruppe und Budget im Werbeanzeigenmanager, bevor Geld ausgegeben wird.',
    barTitle: '{n} Anzeige(n) auf Meta veröffentlichen',
    barActive: 'Sie laufen, sobald sie veröffentlicht sind.',
    barPaused: 'Sie werden ausgeschaltet erstellt – es wird nichts ausgegeben, bis du sie einschaltest.',
    next: {
      performance: {
        title: 'Ergebnisse verfolgen',
        desc: 'Ausgaben, ROAS und Käufe erscheinen auf deinem Dashboard, sobald Meta Daten meldet.',
        cta: 'Zum Dashboard',
      },
      split: {
        title: 'Landingpage per Split-Test prüfen',
        desc: 'Teste Preise, Angebote und Seitenversionen, um die Conversion zu steigern.',
        cta: 'Split-Test starten',
      },
    },
  },
  advertorials: {
    title: 'Advertorials',
    subtitle: 'Erstelle lange redaktionelle Seiten, die sich wie Nachrichtenartikel lesen und Produkte verkaufen',
    generate: 'Advertorial generieren',
    publish: 'Advertorial veröffentlichen',
    published: 'Advertorial veröffentlicht!',
    createAdsQuestion: 'Anzeigen zu diesem Ansatz erstellen?',
    yesCreateAds: 'Ja, Anzeigen erstellen',
    noThanks: 'Nein danke',
    tabCreate: 'Neu erstellen',
    tabPrevious: 'Bereits erstellt',
    allProducts: 'Alle Produkte',
    filterByProduct: 'Nach Produkt filtern',
    noPrevious: 'Noch keine Advertorials — erstelle dein erstes im Tab „Neu erstellen".',
    editWithAi: 'Öffnen & mit KI bearbeiten',
    createAdsFor: 'Anzeigen für das Advertorial erstellen',
    viewLive: 'Live-Seite ansehen',
    updated: 'Advertorial aktualisiert!',
    created: 'Erstellt',
    setupEyebrow: 'Einrichtung',
    setupTitle: 'Wähle ein Produkt und einen Stil',
    startError: 'Das Advertorial konnte nicht gestartet werden',
    progressTitle: 'Dein Advertorial wird geschrieben',
    progressSteps: {
      research: 'Produkt und Zielgruppe werden recherchiert',
      write: 'Der Artikel wird geschrieben',
      images: 'Bilder werden erstellt',
      layout: 'Die Seite wird gestaltet',
    },
    reviewEyebrow: 'Prüfung',
    reviewTitle: 'Dein Advertorial',
    reviewHint: 'Lies es durch, klicke auf beliebige Stellen, um sie zu ändern, und veröffentliche es, wenn du zufrieden bist.',
    draftLabel: 'Entwurf – noch nicht live',
    publishError: 'Das Advertorial konnte nicht veröffentlicht werden',
    liveTitle: 'Dein Advertorial ist live 🎉',
    editInThemeEditor: 'Im Theme-Editor bearbeiten',
    createAnother: 'Weiteres Advertorial erstellen',
    emptyTitle: 'Noch keine Advertorials',
    next: {
      ads: {
        title: 'Anzeigen zu diesem Ansatz erstellen',
        desc: 'Anzeigen, die zu deinem Advertorial führen – gleiche Schritte: Motive → Text → Veröffentlichen.',
      },
      edit: {
        title: 'Alle deine Advertorials ansehen',
        desc: 'Öffne, bearbeite mit KI oder erstelle Anzeigen für jedes frühere Advertorial.',
        cta: 'Alle ansehen',
      },
    },
  },
  products: {
    title: 'Produkte',
    subtitle: 'Alles, was Autonoma erstellt hat oder was in deinem Shop lebt',
    createNew: 'Neues Produkt erstellen',
    createImages: 'Bilder erstellen',
    createPage: 'Produktseite erstellen',
    loading: 'Deine Produkte werden geladen…',
    loadError: 'Deine Produkte konnten nicht geladen werden',
    emptyTitle: 'Noch keine Produkte',
    emptyBody: 'Erstelle dein erstes Produkt – lade ein Foto hoch und wir erstellen Produkt, Bilder und Seite.',
    statusActive: 'Aktiv',
    statusDraft: 'Entwurf',
  },
  newProduct: {
    addPhotos: 'Produktfotos hinzufügen',
    variantName: 'Variantenname',
    variantNameN: 'Name der Variante {n}',
    title: 'Neues Produkt',
    subtitle: 'Lade deine Produktfotos hoch (URL optional) — Autonoma erstellt Produkt und Seite',
    startError: 'Die Erstellung konnte nicht gestartet werden',
    barTitle: 'Bereit, wenn du es bist',
    barReady: 'Wir erstellen Produkt, Bilder und Seite – etwa 5 Minuten.',
    barNeedPhoto: 'Lade mindestens ein Produktfoto hoch, um zu starten.',
    starting: 'Wird gestartet…',
    generateOne: 'Produkt + Seite generieren',
    generateMany: '{n} Produkte + Seiten generieren',
    progressTitle: 'Dein Produkt und deine Seite werden erstellt',
    progressSteps: {
      read: 'Deine Fotos und Notizen werden gelesen',
      write: 'Dein Produkt und deine Seite werden geschrieben',
      images: 'Produktbilder werden erstellt',
      shopify: 'Alles wird in Shopify eingerichtet',
    },
    cancelBuild: 'Diese Erstellung abbrechen',
    cancelConfirm: 'Diese Erstellung abbrechen?',
    cancelTitle: 'Erstellung abbrechen',
    cancelIt: 'Abbrechen',
    previewError: 'Die Seitenvorschau konnte nicht geladen werden',
    loadingPreview: 'Deine Seitenvorschau wird geladen…',
    sections: {
      photos: 'Fotos',
      source: 'Quelle · optional',
      details: 'Details · optional',
      style: 'Seitenstil',
    },
  },
  createImages: {
    settingsSummary: '{product} · {n} Bilder in diesem Durchgang',
    newBatch: 'Neuer Durchgang',
    title: 'Produktbilder erstellen',
    subtitle: 'Frische KI-Produktfotografie aus deinen vorhandenen Aufnahmen',
    progressTitle: '{n} Bilder werden erstellt…',
    progressSteps: {
      study: 'Dein Produkt wird analysiert…',
      design: 'Jede Aufnahme wird geplant…',
      render: 'Bilder werden gerendert…',
      finish: 'Letzter Feinschliff…',
    },
    cancelConfirm: 'Erstellung dieser Bilder abbrechen?',
    cancelTitle: 'Bilder abbrechen',
    publishedTitle: '{n} Bilder in deinem Produkt veröffentlicht 🎉',
    publishedBody: 'Das erste ist jetzt das Hauptbild des Produkts.',
    nextAds: 'Anzeigen mit diesen Bildern erstellen',
    barTitle: 'Produktbilder',
    barSelected: '{n} von {total} ausgewählt',
    downloadSelected: '{n} ausgewählte herunterladen',
    downloadAll: 'Alle herunterladen',
    publishN: '{n} auf der Produktseite veröffentlichen',
  },
  createPage: {
    title: 'Produktseite erstellen',
    subtitle: 'Eine conversion-starke Produktseite für ein bestehendes Produkt',
    progressTitle: 'Deine Produktseite wird erstellt…',
    progressPreview: 'Die Vorschau wird vorbereitet…',
    alreadyGenerating: 'Für dieses Produkt wird bereits eine Seite erstellt – verfolge den Fortschritt in der Anzeige unten rechts.',
  },
  upsell: {
    title: 'Upsell-Entdeckung',
    subtitle: 'Finde ergänzende Produkte, die Wettbewerber mit deinen bündeln — der schnellste Weg zu einem höheren Warenkorbwert',
    flowPick: 'Upsell wählen',
    previewTitle: 'Vorschau deines Upsells',
    publishedTitle: 'Upsell veröffentlicht',
    previewSubtitle: '„{upsell}“ als optionales Add-on für „{main}“',
    liveTitle: 'Dein Upsell ist live 🎉',
    liveBody: 'Es erscheint als optionales Add-on neben „In den Warenkorb“ bei „{main}“. Wer es ankreuzt, bekommt beide Artikel zusammen in den Warenkorb.',
    liveBodyNoBlock: 'Das Upsell-Produkt und seine Seite sind live. Der Add-on-Block braucht einen manuellen Schritt – siehe unten.',
    blockManualTitle: 'Füge den Add-on-Block zu deiner Produktseite hinzu',
    viewMainPage: 'Produktseite ansehen',
    viewUpsellPage: 'Upsell-Seite ansehen',
    nothingLiveTitle: 'Noch ist nichts live',
    nothingLiveBody: 'Prüfe beide Teile unten und verfeinere sie, bis du zufrieden bist, dann veröffentliche. Das Veröffentlichen aktiviert das Upsell-Produkt, schaltet seine Seite live und fügt den optionalen Add-on-Block neben „In den Warenkorb“ bei „{main}“ ein.',
    barLive: 'Live in deinem Shop',
    barDraft: 'Entwurf – veröffentliche beide Teile mit einem Klick',
    publishError: 'Das Upsell konnte nicht veröffentlicht werden',
    publishAll: 'Upsell veröffentlichen',
    republish: 'Erneut veröffentlichen',
    discoverProgressTitle: 'Upsells werden gesucht',
    discoverSteps: {
      scan: 'Dein Katalog wird durchsucht',
      research: 'Es wird recherchiert, was gut zusammenpasst',
      rank: 'Die besten Kombinationen werden sortiert',
    },
    buildProgressTitle: '„{name}“ wird erstellt',
    yourUpsell: 'dein Upsell',
    buildSteps: {
      product: 'Das Upsell-Produkt wird erstellt',
      page: 'Seine Produktseite wird geschrieben',
      block: 'Der Add-on-Block wird gestaltet',
    },
    noneTitle: 'Es kamen keine Empfehlungen zurück',
    noneBody: 'Das passiert gelegentlich – versuche es gleich noch einmal.',
    next: {
      ads: {
        title: 'Anzeigen für das Hauptprodukt erstellen',
        desc: 'Leite Traffic auf die Seite, die jetzt das Upsell enthält.',
        cta: 'Anzeigen erstellen',
      },
      another: {
        title: 'Weiteres Upsell finden',
        desc: 'Füge weiteren Produkten Add-ons hinzu.',
        cta: 'Upsells finden',
      },
    },
  },
  splitTesting: {
    metrics: {
      variant: 'Jede getestete Version',
      split: 'Anteil der Besucher, die diese Version sehen',
      sessions: 'Besuche dieser Version',
      purchases: 'Bestellungen aus dieser Version',
      revenue: 'Umsatz dieser Version',
      cvr: 'Konversionsrate — Bestellungen ÷ Besuche',
      aov: 'Durchschnittlicher Bestellwert — Umsatz ÷ Bestellungen',
      roas: 'Return on Ad Spend — Umsatz ÷ Werbeausgaben',
      rpv: 'Umsatz pro Besucher — Umsatz ÷ Besuche',
      legendProb: 'P(best) = Wahrscheinlichkeit, dass diese Version die beste ist',
      legend: 'CVR = Konversionsrate · AOV = durchschnittlicher Bestellwert · ROAS = Return on Ad Spend · ★ = Ziel dieses Tests',
    },
    title: 'A/B-Tests',
    subtitle: 'Teste Preise, Seiten und Angebote — finde heraus, was am besten konvertiert',
    tabs: {
      create: 'Neu erstellen',
      active: 'Aktiv',
      paused: 'Pausiert',
      completed: 'Abgeschlossen',
    },
    flow: {
      type: 'Testtyp',
      setup: 'Einrichten',
      launch: 'Vorschau & Start',
    },
    pickProduct: 'Wähle ein Produkt',
    whatToTest: 'Was möchtest du testen?',
    previewVariants: 'Vorschau deiner Varianten',
    progressTitle: 'Deine Varianten werden erstellt…',
    progressSteps: {
      read: 'Deine aktuelle Seite wird gelesen…',
      write: 'Jede Variante wird geschrieben…',
      images: 'Bilder werden erstellt…',
      preview: 'Die Vorschauen werden vorbereitet…',
    },
    cancelBuild: 'Diese Erstellung abbrechen',
    cancelConfirm: 'Erstellung dieser Varianten abbrechen?',
    cancelTitle: 'Erstellung abbrechen',
    buildFailedTitle: 'Wir konnten die Varianten nicht erstellen',
    buildFailedHint: 'Passe die Variantenbeschreibungen oben an und versuche es erneut.',
    runningTitle: 'Dein Test läuft 🎉',
    runningBody: 'Der Traffic wird jetzt auf deine Varianten verteilt. Die Ergebnisse aktualisieren sich live, sobald Besucher kommen.',
    viewResults: 'Ergebnisse ansehen',
    viewActive: 'Aktive Tests ansehen',
    createTest: 'Test erstellen',
    emptyActiveTitle: 'Keine aktiven Tests',
    emptyActiveBody: 'Kontinuierliches Testen lässt Shops wachsen – starte mit einem Preis- oder Angebotstest.',
    emptyPausedTitle: 'Keine pausierten Tests',
    emptyPausedBody: 'Das Pausieren eines Tests stoppt die Traffic-Aufteilung und die Datenerfassung – setze ihn jederzeit dort fort, wo er aufgehört hat.',
    parity: {
      blockedTitle: 'Für dieses Produkt ist kein Test mit Varianten-Produkt möglich',
      warnTitle: 'Hinweis: Apps, die an dieses Produkt gekoppelt sind',
      warnFooter: 'Preis-, Bild-, Angebots- und Bundle-Tests leiten Gruppe B auf ein Varianten-Produkt. Lagerbestand, Versandprofil und Rabatte werden während des gesamten Tests automatisch synchron gehalten; die oben genannten Punkte hängen an der Produkt-ID und folgen eventuell nicht. Produktseiten-Tests mit eigenen URLs sind nicht betroffen.',
    },
    storefront: {
      pauseAll: 'Alle Tests pausieren ({n})',
      pauseAllHint: 'Notstopp: pausiert jeden laufenden Test und schaltet das Storefront-Skript ab. Käufer sehen innerhalb von 60 Sekunden wieder deine normalen Seiten.',
      deliveryTitle: 'Deine Tests erreichen Käufer noch nicht',
      deliveryBody: 'In diesem Shop ist weder das alte Autonoma-Script-Tag noch das Autonoma-AI-App-Embed aktiv, daher wird kein Käufer einem Test zugewiesen (Shopify erlaubt seit dem 1. Okt. 2026 keine neuen Script-Tags mehr). Schalte das App-Embed im Theme-Editor ein und klicke auf Speichern — das dauert unter einer Minute.',
      deliveryEnable: 'App-Embed einschalten',
      pauseAllConfirm: 'Alle laufenden Tests pausieren und das Split-Skript im Shop abschalten? Käufer sehen innerhalb von 60 Sekunden deine normalen Seiten. Tests können danach fortgesetzt werden.',
      pausedAllNotice: '{n} Test(s) pausiert und das Storefront-Skript abgeschaltet. Käufer sehen innerhalb von 60 Sekunden deine normalen Seiten.',
      offTitle: 'Split-Tests sind in deinem Shop AUS',
      offBody: 'Solange sie aus sind, wird kein Besucher umgeleitet, nichts ausgeblendet und kein Warenkorb angefasst – bestehende Zuordnungen werden ignoriert.',
      offPauseAll: 'Du hast am {since} alle Tests pausiert.',
      offManual: 'Das Storefront-Skript wurde am {since} abgeschaltet.',
      offParity: 'Autonoma hat das Storefront-Skript am {since} abgeschaltet, weil ein Varianten-Produkt nicht mehr zum Original passte (Details beim pausierten Test).',
      offGlobal: 'Das Autonoma-Team hat Split-Tests für alle Shops vorübergehend abgeschaltet, während ein Problem untersucht wird.',
      turnOn: 'Split-Tests im Shop wieder einschalten',
      errorTitle: 'Das hat nicht geklappt',
    },
    emptyCompletedTitle: 'Noch keine abgeschlossenen Tests',
    emptyCompletedBody: 'Ergebnisse erscheinen hier, sobald ein Test seine Datenschwelle erreicht oder du ihn beendest.',
  },
  website: {
    title: 'Website-Builder',
    subtitle: 'Erstelle einen Multi-Produkt-Shop — Startseite, Navigation, Logo, Firmenname, Richtlinien und Checkout-Branding — rund um deine ausgewählten Produkte',
    startError: 'Die Website-Erstellung konnte nicht gestartet werden',
    previousTitle: 'Frühere Websites',
    previousEmpty: 'Noch keine Website – erstelle unten deine erste.',
    productsError: 'Deine Produkte konnten nicht geladen werden',
    searchProducts: 'Produkte suchen',
    selectAll: 'Alle auswählen',
    clear: 'Auswahl aufheben',
    selectedCount: '{n} von {total} ausgewählt',
    noMatches: 'Keine Produkte passen zu dieser Suche.',
    showAll: 'Alle {n} Produkte anzeigen',
    showFewer: 'Weniger anzeigen',
    barTitle: 'Bereit zum Erstellen',
    barNoProducts: 'Erstelle zuerst ein Produkt.',
    barPickProducts: 'Wähle oben mindestens ein Produkt aus.',
    barTitlePending: 'Fast bereit',
    barNeedName: 'Gib einen Firmennamen ein oder aktiviere „KI soll meinen Firmennamen erstellen“.',
    barReady: 'Erstellung rund um {n} Produkt(e) – etwa 5 Minuten.',
    buildCta: 'Meine Website erstellen',
    progressTitle: 'Deine Website wird erstellt',
    progressSteps: {
      brand: 'Markenname, Farben und Logo werden festgelegt',
      homepage: 'Deine Startseite wird geschrieben',
      images: 'Website-Bilder werden erstellt',
      pages: 'Seiten, Menüs und Kollektionen werden eingerichtet',
    },
    cancelBuild: 'Diese Erstellung abbrechen',
    cancelConfirm: 'Diese Website-Erstellung abbrechen?',
    cancelTitle: 'Website-Erstellung abbrechen',
    liveTitle: 'Deine Website ist live 🎉',
    liveBody: 'Startseite, Über-uns- und Kontaktseite, Richtlinien, Menüs und Kollektionen sind jetzt live in deinem Shop.',
    viewStorefront: 'Live-Shop ansehen',
    openAbout: 'Über-uns-Seite öffnen',
    refineHomepage: 'Startseite verfeinern',
    buildAnother: 'Weitere Website erstellen',
    previewReadyTitle: 'Die Vorschau deiner Website ist fertig',
    previewReadyBody: 'Noch ist nichts live. Prüfe die Vorschau unten, beschreibe gewünschte Änderungen und veröffentliche dann, um die gesamte Website live zu schalten – Seiten, Richtlinien, Menüs und Kollektionen inklusive.',
    logo: {
      eyebrow: 'Dein Logo',
      title: 'Markenlogo',
      dims: 'Transparentes PNG, {w}×{h}',
      sourceGenerated: 'Erstellt für {name}',
      sourceUploaded: 'Dein hochgeladenes Logo',
      sourceTheme: 'Das aktuelle Logo deines Themes',
      sourceBrand: 'Dein Shopify-Markenlogo',
      download: 'PNG herunterladen (280×80)',
      generateAnother: 'Noch eins erstellen',
      uploadOwn: 'Eigenes hochladen',
      undo: 'Rückgängig – vorheriges Logo wiederherstellen',
      generating: 'Ein weiteres Logo wird entworfen…',
      uploading: 'Dein Logo wird hochgeladen…',
      setInTheme: 'Im Theme „{theme}“ gesetzt – {where}',
      whereGlobal: 'Theme-Einstellungen (Logo-Bildauswahl)',
      whereHeader: 'Header-Abschnitt (Logo-Bildauswahl)',
      whereBoth: 'Theme-Einstellungen + Header-Abschnitt',
      keptCurrent: 'Dein aktuelles Logo wurde beibehalten – im Theme wurde nichts ersetzt.',
      notApplied: 'Noch nicht im Theme gesetzt',
      noLogoSetting: 'Dieses Theme hat keine Logo-Bildeinstellung – lade das PNG herunter und füge es im Theme-Editor ein.',
      willApply: 'Veröffentliche die Website, um es im Header deines Themes zu setzen (140 px breit).',
      restored: 'Vorheriges Logo im Theme wiederhergestellt.',
      failed: 'Logo-Aktion fehlgeschlagen',
      choiceTitle: 'Logo',
      choiceHelp: 'Du hast bereits ein Logo. Behalte es oder lass die KI ein neues entwerfen (transparentes PNG, 280×80).',
      useCurrent: 'Mein aktuelles Logo verwenden',
      generateNew: 'Neues Logo erstellen',
      currentFrom: 'Gefunden in: {where}',
      currentTheme: 'deinem Theme',
      currentBrand: 'den Shopify-Markeneinstellungen',
    },
    openPreview: 'Vorschau öffnen & veröffentlichen',
    barDraft: 'Vorschau – noch nicht live',
    pages: {
      home: 'Startseite',
      about: 'Über uns',
      contact: 'Kontakt',
      aboutDesc: 'Die Über-uns-Seite wird aus der Markengeschichte geschrieben und beim Veröffentlichen der Website in deinem Shop angelegt.',
      contactDesc: 'Eine Kontaktseite mit funktionierendem Formular wird beim Veröffentlichen der Website in deinem Shop angelegt.',
    },
    next: {
      ads: {
        title: 'Anzeigen für deine Produkte erstellen',
        desc: 'Bildanzeigen, Videoanzeigen und Anzeigentexte, bereit für den Start auf Meta.',
        cta: 'Anzeigen erstellen',
      },
      split: {
        title: 'Deine Seiten per Split-Test prüfen',
        desc: 'Teste Preise, Angebote und Seitenversionen, um herauszufinden, was verkauft.',
        cta: 'Split-Test starten',
      },
    },
  },
  chat: {
    title: 'KI-Chat',
    subtitle: 'Ändere deinen Shop, deine Produkte und Anzeigen, indem du einfach danach fragst',
    placeholder: 'Frag Autonoma alles über das Wachstum deines Shops...',
    send: 'Senden',
    publishFailed: 'Der Anzeigentext konnte nicht veröffentlicht werden',
  },
  settings: {
    title: 'Einstellungen',
    subtitle: 'Verwalte deinen Shop, dein Werbekonto, Standardwerte und deinen Plan',
    language: 'App-Sprache',
    languageHelp: 'Automatisch aus deinem Shopify-Admin erkannt — ändere sie hier, wenn du möchtest. Ändert die App-Sprache UND die Sprache aller KI-generierten Inhalte (Anzeigen, Seiten, Advertorials, Video-Voiceover).',
    languageSaved: 'Sprache aktualisiert',
    dataSharingTitle: 'Anonymisierte Einblicke',
    dataSharingLabel: 'Teile anonymisierte, aggregierte Nutzungseinblicke, um Autonoma zu verbessern.',
    dataSharingHelp: 'Standardmäßig aktiviert (du kannst es jederzeit in den Einstellungen deaktivieren). Wenn aktiviert, verbessern anonymisierte, aggregierte Muster darüber, welche Anzeigen, Seiten und Angebote konvertieren, die KI-Empfehlungen für alle Shops. Es werden niemals personenbezogene Daten geteilt — weder Kundendaten, Produktnamen, Umsatzzahlen noch die Identität deines Shops.',
    autoImproveTitle: 'Auto-Verbesserung',
    autoImproveLabel: 'Einen Split-Test vorschlagen, wenn eine Seite genug Traffic und eine schwache In-den-Warenkorb-Rate hat.',
    autoImproveHelp: 'Standardmäßig aus. Autonoma misst, wie Käufer sich durch die Abschnitte der von ihm erstellten Seiten bewegen (welche Abschnitte gesehen werden, wie lange, und wo „In den Warenkorb“ passiert – nie, wer der Käufer ist) und schlägt mit dieser Option pro Seite einen Hero- oder Angebots-Split-Test als Benachrichtigung vor. Du prüfst jede Variante, bevor Traffic aufgeteilt wird; nichts startet von selbst.',
    autoImproveStats: '{views} Seitenaufrufe auf {pages} Autonoma-Seiten in den letzten {days} Tagen · Vorschläge ab {min} Aufrufen pro Seite.',
    autoImproveNoData: 'Noch keine Seitenaufrufe gemessen – mit der aktuellen Abschnittsbibliothek erstellte Seiten melden, sobald Käufer sie besuchen.',
    onThisPage: 'Auf dieser Seite',
    saveFailed: 'Speichern nicht möglich',
    metaConnectError: 'Dein Meta-Konto konnte nicht verbunden werden',
    sections: {
      plan: 'Tarif & Nutzung',
      meta: 'Meta-Werbekonto',
      defaults: 'Anzeigen-Standards',
      themeEditor: 'Theme-Editor',
      mobile: 'Mobile App',
      referrals: 'Empfehlen & verdienen',
      privacy: 'Datenschutz',
    },
  },
  plans: {
    title: 'Wähle deinen Plan',
    subtitle: '{plans} enthalten eine kostenlose {n}-Tage-Testphase. Jederzeit kündbar.',
    subtitleNoTrial: 'Jederzeit kündbar.',
    andPlans: 'und',
    perMonth: '/Monat',
    trialChip: '{n} Tage kostenlos testen',
    billedToday: 'Abrechnung heute',
    mostPopular: 'Am beliebtesten',
    startTrial: 'Kostenlos testen',
    choose: '{name} wählen',
    opening: 'Shopify wird geöffnet…',
    loading: 'Pläne werden geladen',
    loadError: 'Pläne konnten nicht geladen werden — bitte Seite aktualisieren.',
    declined: 'Du musst einen Plan annehmen, um fortzufahren — wähle unten einen aus.',
    unverified: 'Wir konnten dein Abo noch nicht bei Shopify bestätigen. Wenn du die Zahlung genehmigt hast, klicke auf „Erneut prüfen“ — sonst wähle unten einen Plan.',
    checkAgain: 'Erneut prüfen',
    checking: 'Wird geprüft…',
    contactSupport: 'Support kontaktieren',
    reactivateTitle: 'Dein Abo ist inaktiv',
    reactivateSubtitle: 'Reaktiviere es, um deine Seiten, Produkte und Anzeigen wiederherzustellen — nichts wird gelöscht.',
    reactivateReason: {
      cancelled: 'Dein Autonoma-Abo wurde gekündigt.',
      frozen: 'Dein Abo ist eingefroren — Shopify konnte die letzte Zahlung nicht einziehen.',
      declined: 'Die Abo-Zahlung wurde abgelehnt.',
      expired: 'Dein Abo ist abgelaufen.',
      pending: 'Dein Abo wartet noch auf die Genehmigung in Shopify.',
      test_charge_on_live_store: 'Dieses Test-Abo ist in einem echten Shop nicht gültig.',
      inactive: 'Dein Autonoma-Abo ist nicht mehr aktiv.',
    },
    reactivateCta: '{name} reaktivieren',
    unavailableTitle: 'Wir konnten dein Abo nicht bestätigen',
    unavailableBody: 'Shopify hat nicht rechtzeitig geantwortet, daher kann Autonoma noch nicht geöffnet werden. Nichts geht verloren — versuche es gleich noch einmal.',
    tryAgain: 'Erneut versuchen',
    checkingAccess: 'Dein Abo wird geprüft…',
    genericError: 'Etwas ist schiefgelaufen — bitte erneut versuchen.',
    keyNumbersTitle: 'Pro Monat',
    notIncluded: 'Nicht enthalten',
    inherits: 'Alles aus {name}, plus:',
    customLine: 'Höhere Limits oder White-Label nötig? Individuelle Pläne für Agenturen und umsatzstarke Marken —',
    customCta: 'Gespräch buchen →',
    compare: 'Alle Funktionen vergleichen',
    close: 'Schließen',
    trustRow: 'Sichere Abrechnung über Shopify · Jederzeit kündbar · Plan jederzeit wechseln',
    consentTitle: 'Teile anonymisierte Einblicke, um Autonoma zu verbessern',
    consentBody: 'Teile anonymisierte, aggregierte Nutzungseinblicke, um Autonoma zu verbessern. Es werden niemals personenbezogene Daten geteilt. Du kannst das jederzeit in den Einstellungen ändern.',
    consentDefault: 'Standardmäßig aktiviert (du kannst es jederzeit in den Einstellungen deaktivieren).',
    consentInfo: 'Mehr zum Teilen anonymisierter Einblicke',
    billingNote: 'Die Abrechnung erfolgt sicher über Shopify und erscheint auf deiner Shopify-Rechnung. Mit dem Abonnement akzeptierst du unsere',
    and: 'und unsere',
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutzerklärung',
    // Client fallback for backends without plan.copy.tagline / highlights
    // (the server copy in plan-copy.service.js is the source of truth).
    tiers: {
      starter: {
        tagline: 'Starte deine ersten Gewinnerprodukte',
        highlights: ['KI-Produktseiten', 'Bildanzeigen mit Sale-Badges', 'Advertorials, die vorverkaufen', 'Marken-Website + Logo'],
      },
      growth: {
        tagline: 'Anzeigen schalten, mehr pro Bestellung',
        highlights: ['Anzeigen direkt auf Meta', 'Hochformat-Feed-Anzeigen (4:5)', 'Post-Purchase-Upsells', 'iPhone- & Android-App'],
      },
      scale: {
        tagline: 'Videoanzeigen, Split-Tests und KI-Chat',
        highlights: ['KI-Videoanzeigen', 'Split-Tests mit klarem Sieger', 'KI-Assistent, der die Arbeit macht', 'Priorisierter Support'],
      },
      enterprise: {
        tagline: 'Für Agenturen und umsatzstarke Marken',
        highlights: ['Höchste Limits für alles', 'Täglich neue Winkel testen', 'Dediziertes Onboarding', 'Priorisierter Support'],
      },
    },
    keyNumbers: {
      productBuilds: 'Produktseiten',
      imageAds: 'Bildanzeigen',
      videoAds: 'Videoanzeigen',
      advertorials: 'Advertorials',
      splitTests: 'Split-Tests',
      findProductsSearches: 'Produktsuchen',
    },
    currentPlan: 'Aktueller Plan',
  },
  planLimit: {
    titleReached: 'Du hast dein Plan-Limit erreicht',
    titleNotEnough: 'Diesen Monat reicht es nicht mehr',
    titleNear: 'Diesen Monat wird es knapp',
    reached: 'Du hast alle {n} {feature} auf {plan} diesen Monat verbraucht. Upgrade, um weiterzumachen — dein Limit wird am {date} zurückgesetzt.',
    reachedBudget: 'Du hast dein gesamtes {feature} von {n} auf {plan} diesen Monat verbraucht. Upgrade, um weiterzumachen — dein Limit wird am {date} zurückgesetzt.',
    notEnough: 'Du hast diesen Monat noch {x} {feature}. Hierfür werden {y} benötigt. Führe jetzt ein Upgrade durch, um fortzufahren.',
    notEnoughBudget: 'Du hast diesen Monat noch {x} {feature}. Hierfür werden {y} benötigt. Führe jetzt ein Upgrade durch, um fortzufahren.',
    notEnoughUnknown: 'Du hast diesen Monat noch {x} {feature} — das reicht hierfür nicht. Führe jetzt ein Upgrade durch, um fortzufahren.',
    left: 'Du hast diesen Monat noch {x} {feature}.',
    allowance: '{n} {feature} / Monat',
    allowanceBudget: '{n} {feature} / Monat',
    allowanceUnlimited: 'Unbegrenzt {feature}',
    allowanceNone: 'Nicht in diesem Plan',
    topTierTitle: 'Du bist auf unserem höchsten Plan',
    topTierBody: 'Du brauchst diesen Monat mehr {feature}? Für Agenturen und Marken mit hohem Volumen richten wir individuelle Pläne mit höheren Limits ein.',
    topTierCta: 'Kontaktiere uns für einen individuellen Plan',
    referLine: 'Oder empfiehl einen Shop — ihr bekommt beide Bonus-Credits.',
    referCta: 'Empfehlen & verdienen',
    nearLimit: 'Noch {n} {feature} diesen Monat',
    nearLimitBudget: 'Noch {n} {feature} diesen Monat',
    viewPlans: 'Pläne ansehen',
    upgraded: 'Plan aktualisiert — du kannst jetzt generieren.',
    loadError: 'Pläne konnten nicht geladen werden — bitte versuche es erneut.',
    subscribeError: 'Das Upgrade konnte nicht gestartet werden — bitte versuche es erneut.',
    close: 'Schließen',
  },
  generations: {
    title: 'Frühere Erstellungen',
    tabAll: 'Alle',
    tabTrash: 'Papierkorb',
    trashNote: 'Gelöschte Elemente bleiben {n} Tage hier – stelle sie wieder her oder lösche sie endgültig.',
    trashEmpty: 'Der Papierkorb ist leer.',
    empty: 'Noch nichts erstellt.',
    viewEdit: 'Ansehen / Bearbeiten',
    moveToTrash: 'In den Papierkorb',
    restore: 'Wiederherstellen',
    deleteForever: 'Endgültig löschen',
    deletedIn: 'wird {when} endgültig gelöscht',
    status: {
      draft: 'Entwurf',
      published: 'Veröffentlicht',
      replaced: 'Ersetzt',
      trashed: 'Im Papierkorb',
    },
  },
  productDetail: {
    loading: 'Produkt wird geladen…',
    loadError: 'Dieses Produkt konnte nicht geladen werden',
    backToProducts: 'Zurück zu den Produkten',
    editInShopify: 'In Shopify bearbeiten',
    draftNote: 'Entwurf – veröffentliche das Produkt in Shopify, um einen Link zur Live-Seite zu erhalten.',
    whatToCreate: 'Was möchtest du erstellen?',
    pagesTitle: 'Produktseiten für dieses Produkt',
    pagesEmpty: 'Für dieses Produkt wurde noch keine Produktseite erstellt.',
    pagesEmptyCta: 'Produktseite erstellen',
    othersTitle: 'Advertorials und Anzeigenpakete für dieses Produkt',
    othersEmpty: 'Noch keine Advertorials oder Anzeigenpakete.',
    chatPrompt: 'Möchtest du die Änderung lieber einfach beschreiben?',
    chatCta: 'Mit der KI chatten',
    actions: {
      ads: {
        title: 'Anzeigen für dieses Produkt erstellen',
        desc: 'Bild- und Video-Werbemotive, bereit zur Veröffentlichung auf Meta.',
      },
      images: {
        title: 'Produktbilder erstellen',
        desc: 'Neue KI-Produktfotografie auf Basis deiner vorhandenen Aufnahmen.',
      },
      page: {
        title: 'Produktseite erstellen',
        desc: 'Eine conversionstarke Produktseite im Stil deiner Wahl.',
      },
      advertorial: {
        title: 'Advertorial erstellen',
        desc: 'Ein redaktionell wirkender Artikel, der verkauft – Story, Recherche, Liste.',
      },
      splitTest: {
        title: 'Split-Test erstellen',
        desc: 'Teste Preise, Angebote oder Produktseiten gegeneinander.',
      },
      upsell: {
        title: 'Upsell-Produkte finden',
        desc: 'Entdecke ergänzende Produkte, die deinen durchschnittlichen Bestellwert erhöhen.',
      },
    },
  },
  flow: {
    product: 'Produkt',
    build: 'Erstellung',
    review: 'Prüfung',
    publish: 'Veröffentlichen',
    setup: 'Einrichtung',
    customise: 'Anpassen',
    preview: 'Vorschau',
    results: 'Ergebnisse',
  },
  findProducts: {
    title: 'Produkte finden',
    subtitle: 'Gewinnerprodukte, belegt durch echte Werbeausgaben – bei jeder Suche neue Treffer',
    progressTitle: 'Suche nach Gewinnerprodukten',
    progressSteps: {
      scan: 'Es wird geprüft, was sich gerade verkauft',
      filter: 'Es wird nach deiner Nische gefiltert',
      rank: 'Die stärksten Treffer werden sortiert',
    },
    cancelConfirm: 'Diese Suche abbrechen?',
    cancelTitle: 'Suche abbrechen',
    noneTitle: 'Keine Gewinnerprodukte in dieser Kategorie',
    noneBody: 'Probiere eine andere Kategorie oder starte die Suche erneut – die Treffer sind jedes Mal neu.',
  },
  ui: {
    nav: {
      menuLabel: 'Navigationsmenü',
      lockedTitle: 'Upgrade, um {name} freizuschalten',
    },
    progress: {
      done: 'Fertig!',
      anyMoment: 'Jeden Moment…',
      longer: 'Dauert etwas länger als üblich…',
      minutesLeft: 'Noch etwa {n} Min.',
      oneMinuteLeft: 'Noch etwa 1 Min.',
      secondsLeft: 'Noch etwa {n} s',
      leaveNote: 'Wir benachrichtigen dich, wenn es fertig ist – du kannst diese Seite verlassen.',
      cancel: 'Abbrechen',
    },
    errors: {
      retry: 'Erneut versuchen',
      reload: 'Seite neu laden',
      showDetails: 'Technische Details',
      hideDetails: 'Details ausblenden',
      generic: {
        title: 'Etwas hat nicht geklappt',
        body: 'Bitte versuche es erneut. Wenn es weiterhin passiert, schreib uns über den Support-Button.',
      },
      network: {
        title: 'Autonoma ist nicht erreichbar',
        body: 'Prüfe deine Internetverbindung und versuche es erneut.',
      },
      session: {
        title: 'Deine Sitzung ist abgelaufen',
        body: 'Lade die Seite neu, um dich wieder anzumelden – deine Arbeit ist gespeichert.',
      },
      quota: {
        title: 'Du hast dein Tariflimit erreicht',
        body: 'Führe ein Upgrade durch oder warte auf deinen nächsten Abrechnungszeitraum, um fortzufahren.',
      },
      notFound: {
        title: 'Das konnten wir nicht finden',
        body: 'Es wurde möglicherweise entfernt. Geh zurück und versuche es erneut.',
      },
      busy: {
        title: 'Läuft bereits',
        body: 'Das ist bereits in Arbeit – sieh dir die Fortschrittsanzeige unten rechts an.',
      },
      tooLarge: {
        title: 'Diese Datei ist zu groß',
        body: 'Versuche es mit einer kleineren Datei.',
      },
      rateLimit: {
        title: 'Zu viele Anfragen',
        body: 'Warte eine Minute und versuche es erneut.',
      },
      timeout: {
        title: 'Das hat zu lange gedauert',
        body: 'Die Anfrage ist abgelaufen. Versuche es erneut – beim zweiten Mal klappt es meistens.',
      },
      server: {
        title: 'Bei uns ist etwas schiefgelaufen',
        body: 'Bitte versuche es gleich noch einmal.',
      },
    },
    preview: {
      label: 'Vorschau',
      device: 'Vorschaugerät',
      desktop: 'Desktop',
      mobile: 'Mobil',
      edit: 'Bearbeiten',
      clickToEdit: 'Vorschau · zum Bearbeiten klicken',
      editPage: 'Diese Seite bearbeiten',
    },
    success: {
      whatNext: 'Was möchtest du als Nächstes tun?',
    },
    session: {
      title: 'Wir konnten keine Verbindung zu deinem Shop herstellen',
      body: 'Deine Shopify-Sitzung funktioniert gerade nicht. Neu verbinden behebt das meistens.',
    },
    themeCode: {
      getting: 'Code wird geholt…',
      error: 'Wir konnten deinen Code nicht abrufen',
    },
    editor: {
      opening: 'Seite wird geöffnet…',
      archivedTitle: 'Diese Seite wurde archiviert',
      openError: 'Wir konnten diese Seite nicht öffnen',
      publishError: 'Die Veröffentlichung hat nicht geklappt',
      upToDate: '✓ Live · aktuell',
      upToDateHint: 'Alles auf dieser Seite ist live. Nimm eine Änderung vor, und der Button „Veröffentlichen“ erscheint wieder.',
      back: '← Zurück',
    },
    jobs: {
      ads: 'Anzeigen werden erstellt',
      advertorial: 'Advertorial wird erstellt',
      landing_page: 'Produktseite wird erstellt',
      website: 'Website wird erstellt',
      images: 'Bilder werden erstellt',
      product_build: 'Produkt wird erstellt',
      split_test_build: 'Testvarianten werden erstellt',
      split_test_setup: 'Split-Test wird eingerichtet',
      upsell_discovery: 'Upsells werden gesucht',
      upsell_build: 'Upsell wird erstellt',
      product_finder: 'Gewinnerprodukte werden gesucht',
      edit_own_ad: 'Deine Anzeigen werden bearbeitet',
      ad_copy: 'Anzeigentext wird geschrieben',
      cart_upgrade: 'Dein Warenkorb wird aufgewertet',
      publish_ads: 'Anzeigen werden veröffentlicht',
      shipping_setup: 'Versand wird eingerichtet',
      markets_update: 'Märkte werden aktualisiert',
      working: 'In Arbeit',
      updating: '{what} wird aktualisiert',
    },
  },
  feedback: {
    thanksTitle: 'Danke für dein Feedback',
    gotIt: 'Angekommen — Ticket #{ticket}',
    gotItBody: 'Ein echter Mensch aus dem Autonoma-Team liest jede dieser Nachrichten. Falls wir mehr Details brauchen, antworten wir an die E-Mail-Adresse deines Shops{email}.',
    backToDashboard: 'Zurück zum Dashboard',
    sendAnother: 'Noch eins senden',
  },
  featureRequest: {
    button: 'Funktion vorschlagen',
    title: 'Funktion vorschlagen',
    intro: 'Sag uns, was Autonoma können soll – neue Funktionen, Verbesserungen, alles. Wir lesen jeden Vorschlag.',
    label: 'Dein Vorschlag',
    placeholder: 'z. B. Anzeigen zu einer festen Uhrzeit starten lassen…',
    send: 'Vorschlag senden',
    tooShort: 'Erzähl uns etwas mehr (mindestens 10 Zeichen).',
    tooLong: 'Bitte halte deinen Vorschlag unter 2.000 Zeichen.',
    successTitle: 'Danke – dein Vorschlag wurde gesendet.',
    successBody: 'Wir melden uns, falls wir mehr Details brauchen.',
    reference: 'Referenz Nr. {ticket}',
    errorGeneric: 'Dein Vorschlag konnte nicht gesendet werden – bitte versuch es noch einmal.',
    retry: 'Erneut versuchen',
  },
  referAndEarn: {
    shareYourLink: 'Teile deinen Link',
  },
  // Arbeitsbereich „Prüfen & veröffentlichen“
  review: {
    top: {
      back: 'Zurück',
      breadcrumb: 'Wo du bist',
      live: 'Live in deinem Shop',
      draft: 'Entwurf — noch nicht live',
      page: 'Seite',
      part: 'Teil der Seite',
      productCard: 'Produktkarte',
      landingPage: 'Landingpage',
      undo: 'Rückgängig',
      redo: 'Wiederholen',
      history: 'Versionsverlauf',
      themeEditor: 'Im Theme-Editor öffnen',
      viewOnStore: 'Im Shop ansehen',
      panel: 'Bearbeitungsleiste ein- oder ausblenden',
      zoom: 'Vorschau-Zoom',
      zoomFit: 'Anpassen',
      expand: 'Vorschau vergrößern',
      collapse: 'Vollbild beenden',
    },
    canvas: {
      toolbar: 'Aktionen für {label}',
      editWithAi: 'Mit KI bearbeiten',
      replaceImage: 'Bild ersetzen',
      moveUp: 'Nach oben',
      moveDown: 'Nach unten',
      duplicate: 'Duplizieren',
      hide: 'Ausblenden',
      show: 'Einblenden',
      delete: 'Löschen',
      deleteIt: 'Löschen',
      thisElement: 'dieses Element',
      deleteConfirm: '„{label}“ löschen? Du kannst das danach rückgängig machen.',
      locked: 'Kauf-Buttons lassen sich hier nicht bearbeiten',
      updating: '{label} wird aktualisiert…',
      updatingPage: 'Die ganze Seite wird aktualisiert…',
      saving: 'Wird gespeichert…',
      failed: 'Die Änderung wurde nicht übernommen',
      failedOn: 'Die Änderung an {label} wurde nicht übernommen',
      retry: 'Erneut versuchen',
      plainFallback: 'stattdessen wird die einfache Vorschau gezeigt.',
    },
    composer: {
      editing: 'Bearbeiten: {label}',
      wholePage: 'Ganze Seite',
      clearScope: 'Auswahl aufheben',
      placeholder: 'Beschreibe eine Änderung für die ganze Seite…',
      placeholderScoped: 'Beschreibe eine Änderung für {label}…',
      wholePageBusy: 'Die ganze Seite wird aktualisiert — du kannst dich weiter umsehen.',
      cancelConfirm: 'Diese Aktualisierung abbrechen?',
      cancelTitle: 'Aktualisierung abbrechen',
      cancelIt: 'Abbrechen',
    },
    prompts: {
      pagePremium: 'Hochwertigerer Ton',
      pageShorter: 'Alles um 20 % kürzen',
      pageFaq: 'FAQ-Abschnitt hinzufügen',
      pageStory: 'Die Geschichte persönlicher machen',
      pageCta: 'Den Call-to-Action stärken',
      headlinePunchier: 'Headline knackiger machen',
      headlineShorter: 'Kürzen',
      headlineBenefit: 'Mit dem Hauptnutzen beginnen',
      textTighter: 'Text straffen',
      textConcrete: 'Konkreter machen',
      textFriendly: 'Freundlicher machen',
      buttonAction: 'Handlungsorientiert formulieren',
      buttonUrgency: 'Etwas Dringlichkeit hinzufügen',
      imageLifestyle: 'Lifestyle-Bild verwenden',
      imageBrighter: 'Hellerer, klarerer Hintergrund',
      sectionTrust: 'Vertrauenssiegel hinzufügen',
      sectionTighter: 'Text straffen',
      sectionTestimonial: 'Kundenstimme hinzufügen',
    },
    panel: {
      label: 'Bearbeitungsleiste',
      collapse: 'Leiste einklappen',
      open: 'Leiste',
      tabs: { edit: 'Bearbeiten', sections: 'Abschnitte', images: 'Bilder', brand: 'Marke', details: 'Details' },
    },
    edit: {
      emptyTitle: 'Nichts ausgewählt',
      emptyBody: 'Klicke auf einen beliebigen Teil der Seite, um ihn zu bearbeiten.',
      inSection: 'in {section}',
      noFields: 'Dieser Teil hat keine Text- oder Bildfelder — nutze „Mit KI bearbeiten“.',
      buttonLabel: '{label} · Beschriftung',
      buttonLink: '{label} · Link',
      saved: 'Gespeichert',
      hintEnter: 'Enter zum Speichern',
      hintBlur: 'Wird beim Verlassen des Felds gespeichert',
      replace: 'Ersetzen',
      generate: 'Generieren',
      upload: 'Hochladen',
      uploading: 'Wird hochgeladen…',
      uploadFailed: 'Das Bild konnte nicht hochgeladen werden.',
      pickImage: 'Bild auswählen',
      noLibrary: 'Für dieses Produkt gibt es noch keine generierten Bilder — lade eines hoch.',
      useImage: 'Bild verwenden',
      generatePrompt: 'Erzeuge ein neues Bild für diese Stelle — gleiches Produkt, klarere Komposition. Häng eine Referenz an, wenn du einen bestimmten Look willst.',
    },
    sections: {
      hide: '{label} ausblenden',
      show: '{label} einblenden',
      none: 'Auf dieser Seite wurden keine Abschnitte gefunden.',
      add: 'Abschnitt hinzufügen',
      dragHint: 'Ziehe am Griff, um die Reihenfolge zu ändern. Ausgeblendete Abschnitte bleiben in der Seite, erscheinen aber nicht im Shop.',
      libraryTitle: 'Abschnitt hinzufügen',
      libraryHint: 'Die KI schreibt den Abschnitt für diese Seite und platziert ihn nach dem Teil, den du gerade ansiehst.',
      placeAfter: 'Platziere ihn direkt nach dem Abschnitt „{section}“.',
      library: {
        benefits: { name: 'Vorteile', desc: 'Drei bis vier Vorteile mit Icons.', instruction: 'Füge einen Vorteile-Abschnitt mit 3–4 konkreten Vorteilen hinzu, jeweils mit kurzer Überschrift, einem Satz und einem einfachen Icon.' },
        testimonials: { name: 'Kundenstimmen', desc: 'Kundenzitate mit Namen und Bewertung.', instruction: 'Füge einen Abschnitt mit drei glaubwürdigen Kundenzitaten hinzu, mit Vornamen, Orten und 5-Sterne-Bewertungen.' },
        faq: { name: 'FAQ', desc: 'Fünf häufige Fragen vor dem Kauf.', instruction: 'Füge einen FAQ-Abschnitt mit fünf echten Fragen vor dem Kauf und beruhigenden, konkreten Antworten hinzu.' },
        gallery: { name: 'Bildergalerie', desc: 'Ein Raster der vorhandenen Bilder.', instruction: 'Füge eine Bildergalerie hinzu, die nur bereits auf der Seite vorhandene Bilder in einem sauberen Raster nutzt.' },
        comparison: { name: 'Vergleichstabelle', desc: 'Wir im Vergleich zu den üblichen Alternativen.', instruction: 'Füge eine Vergleichstabelle hinzu: dieses Produkt gegenüber typischen Alternativen, 4–5 Zeilen, mit Haken und Kreuzen.' },
        howItWorks: { name: 'So funktioniert’s', desc: 'Drei nummerierte Schritte.', instruction: 'Füge einen Abschnitt „So funktioniert’s“ mit drei nummerierten Schritten hinzu, jeweils mit kurzer Überschrift und einem Satz.' },
        guarantee: { name: 'Garantie', desc: 'Geld-zurück-Versprechen und Versandhinweise.', instruction: 'Füge einen Garantie-Abschnitt hinzu: Geld-zurück-Versprechen, Versand und Rücksendungen in einfachen Worten, mit einem Siegel.' },
        cta: { name: 'Call-to-Action', desc: 'Ein abschließendes Banner mit Button.', instruction: 'Füge ein abschließendes Call-to-Action-Banner mit starker Überschrift, einer Zeile Zuspruch und einem Button zum vorhandenen Kauf-Button oder Produkt hinzu.' },
      },
    },
    brand: {
      noLogo: 'Für diese Website wurde noch kein Logo generiert.',
      colours: 'Markenfarben',
      fonts: 'Schriften',
      change: 'Ändern',
      noColours: 'Die Markenfarben kommen aus deinem Theme.',
      headingFont: 'Überschriften',
      bodyFont: 'Fließtext',
      themeDefault: 'Theme-Standard',
    },
    details: {
      product: 'Produkt',
      title: 'Titel',
      price: 'Preis',
      compareAt: 'Vergleichspreis',
      none: 'Keiner',
      status: 'Status',
      productHint: 'Titel, Preis und Vergleichspreis kommen aus Shopify. Bearbeite sie dort — die Seite wird beim Veröffentlichen aktualisiert.',
      editInShopify: 'Produkt in Shopify bearbeiten',
      advertorial: 'Advertorial',
      headline: 'Headline',
      linkedProduct: 'Verknüpftes Produkt',
      ctaOk: 'Der Call-to-Action verlinkt auf {product}.',
      ctaOther: 'Der Call-to-Action verlinkt auf ein anderes Produkt.',
      ctaMissing: 'Kein Link zum Produkt gefunden — füge einen hinzu, damit Leser kaufen können.',
      openProduct: 'Produkt öffnen',
    },
    pages: {
      publishesWithSite: 'Diese Seite wird beim Veröffentlichen der Website erstellt.',
    },
    coach: {
      step: '{n} von {total}',
      clickTitle: 'Klicke auf einen Teil, um ihn zu bearbeiten',
      clickBody: 'Fahre mit der Maus darüber, um zu sehen, was du ändern kannst, klicke zum Auswählen — dann nutze die schwebende Leiste oder das Panel rechts.',
      composerTitle: 'Oder beschreibe hier eine Änderung',
      composerBody: 'Schreib in eigenen Worten, was du willst. Mit einer Auswahl bleibt die Änderung darin; sonst gilt sie für die ganze Seite.',
      publishTitle: 'Veröffentliche, wenn du zufrieden bist',
      publishBody: 'Nichts ist live, bevor du auf Veröffentlichen drückst. Jede Änderung wird gespeichert und lässt sich rückgängig machen.',
      skip: 'Überspringen',
      gotIt: 'Verstanden',
    },
    bar: {
      publish: 'In meinem Shop veröffentlichen',
      update: 'Live-Seite aktualisieren',
      publishing: 'Wird veröffentlicht…',
      saveDraft: 'Entwurf speichern',
      checking: 'Wird geprüft…',
      review: 'Prüfen',
      oneIssue: '1 Problem blockiert die Veröffentlichung',
      nIssues: '{n} Probleme blockieren die Veröffentlichung',
      oneSuggestion: '1 Vorschlag',
      nSuggestions: '{n} Vorschläge',
      blockedTooltip: 'Veröffentlichen ist blockiert',
      blockedTooltipAction: 'Klicke, um zu prüfen und zu beheben.',
      blockedBy: 'blockiert durch {n} Problem(e)',
      whyBlocked: 'Warum kann ich nicht veröffentlichen? Probleme ansehen',
      savedJustNow: 'Gerade gespeichert',
      savedAgo: 'Vor {n} Min. gespeichert',
      allSaved: 'Alle Änderungen gespeichert',
    },
  },
};

export default de;
